import { ADVISOR_AGREEMENT_FRAGMENT } from '@src/gql/fragments/AdvisorAgreementFragment'
import { gql } from '@src/lib/gql'

export const UPSERT_ADVISOR_AGREEMENT = gql`
  mutation UpsertAdvisorAgreement($input: UpsertAdvisorAgreementInput!) {
    upsertAdvisorAgreement(input: $input) {
      advisorAgreement {
        ...AdvisorAgreementFragment
      }
    }
  }
  ${ADVISOR_AGREEMENT_FRAGMENT}
`
